import { Images } from "../../Assets/Index";
import { useDispatch, useSelector } from "react-redux";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";
import {
  Avatar,
  Button,
  DatePicker,
  Drawer,
  InputNumber,
  Space,
  Upload,
} from "antd";
import { LiaCitySolid } from "react-icons/lia";
import { PiCity, PiHandWithdraw } from "react-icons/pi";
import { IoCaretBack, IoCloudUploadOutline } from "react-icons/io5";
import { FaCalendar, FaMoneyBillTransfer } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useCommmonStore } from "../../Store/CommonReducer";
import { BiMoneyWithdraw } from "react-icons/bi";
import { AddFundReq, AddWithdrawalReq, getProfile } from "./WalletApi";
import { useEffect, useState } from "react";
import { RiFundsBoxFill } from "react-icons/ri";
const Wallet = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const [amount, setAmount] = useState();
  const [openBet, setOpenBet] = useState(false);
  const [type, setType] = useState("");
  const [image, setImage] = useState([]);
  const [binaryImage, setBinaryImage] = useState(null);

  const navigate = useNavigate();
  const { profileDetail, setProfileDetail } = useCommmonStore();
  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    UserProfile();
  }, []);

  const WithdrawRequest = () => {
    const formdata = new FormData();
    formdata.append("amount", Number(amount));
    AddWithdrawalReq(formdata)
      .then((res) => {
        if (res.status) {
          // setMatchData(res.data.data);
          dispatchtoast(res.message);
          setAmount();
          UserProfile();
        }
      })
      .catch((err) => console.log(err));
  };
  const FundRequest = () => {
    const formdata = new FormData();
    formdata.append("image", binaryImage);
    formdata.append("amount", Number(amount));
    AddFundReq(formdata)
      .then((res) => {
        if (res.status) {
          // setMatchData(res.data.data);
          dispatchtoast(res.message);
          setAmount();
          setBinaryImage(null);
          setImage([]);
          UserProfile();
        } else {
          setAmount();
          setBinaryImage(null);
          setImage([]);
          UserProfile();
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCustomReq = async ({ file, onSuccess, onError }) => {
    try {
      setBinaryImage(file);
      const dataUrl = await readFileAsDataUrl(file);
      const newFile = {
        ...file,
        name: file.name,
        thumbUrl: dataUrl,
      };
      setImage([newFile]);
      //   setImageBase64(base64Data);
      onSuccess();
    } catch (error) {
      console.error(error);
      onError(error);
    }
  };

  const readFileAsDataUrl = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <>
      <div className="flex justify-center  items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {/* {getLocalStorageItem("userDetails")?.name}Wallet */}
                Wallet
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="overflow-y-scroll h-[100vh]">
            {" "}
            <div>
              <div className="m-4 bg-black ">
                <div
                  className="grid grid-cols-[75%_25%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  justify-around rounded-lg mt-6 p-5  border-none"
                >
                  <div className="text-left custome text-sm text-white cursor-pointer">
                    <p> ₹ {profileDetail?.user?.wallet_balance ?? 0}</p>
                    <p>Available Balance</p>
                  </div>

                  <Button
                    onClick={() => {
                      setOpenBet(true);
                      setType("Withdraw");
                    }}
                    type="default"
                    className=" text-sm custome rounded-lg h-10 font-medium border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                  >
                    Withdraw
                  </Button>
                </div>
                <div
                  className="grid grid-cols-[38%_35%_25%] custome gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  justify-between rounded-lg mt-6 p-5  border-none"
                >
                  <div className="text-left  text-sm text-white cursor-pointer">
                    {/* <p>Commission</p>
                    <p> ₹ {profileDetail?.user?.wallet_balance ?? 0}</p> */}
                  </div>
                  <div className="text-left  text-sm text-white cursor-pointer">
                    {/* <p>Bonus </p>
                    <p> ₹ {profileDetail?.user?.wallet_balance ?? 0}</p> */}
                  </div>
                  <Button
                    onClick={() => {
                      setOpenBet(true);
                      setType("FundReq");
                    }}
                    type="default"
                    className=" text-sm custome rounded-lg h-10 font-medium border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                  >
                    Add Fund
                  </Button>
                </div>

                {/* <div>
                  <div className="flex p-2 justify-between">
                    <p className="custome text-xs text-white">
                      Recent Transactions
                    </p>
                    <p
                      className="custome text-xs text-white cursor-pointer"
                      onClick={() => navigate("/transaction_history")}
                    >
                      See All{" "}
                    </p>
                  </div>
                  <div
                    className="grid grid-cols-[18%_55%_25%] custome gap-2 bg-black shadow-inner shadow-[#ba7d13]
                  justify-between rounded-lg mt-6 p-5  border-none"
                  >
                    <div className=" flex text-center items-center  text-sm text-white cursor-pointer">
                      <PiCity />
                    </div>
                    <div className="text-left  text-white cursor-pointer">
                      <p>Bonus Balance</p>
                      <p className=" text-xs">Txn id - ed2faa142fce2d4</p>
                      <p className=" text-xs">2025-05-29 01:28:52 PM</p>
                    </div>
                    <p className="text-green-600 text-sm text-center">+50</p>
                  </div>
                </div> */}
                <div className="flex justify-between gap-2 sm:gap-4 m-2 sm:m-4">
                  <div
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() =>
                      navigate("/wallet/show_Wallet_fund_History", {
                        state: {
                          type: "withdrawHistory",
                        },
                      })
                    }
                  >
                    <Avatar
                      size="large"
                      icon={<PiHandWithdraw />}
                      className="border-none bg-[#ba7d13]"
                    />
                    <span className="mt-2 text-lg text-white custome text-center">
                      Withdraw Request History
                    </span>
                  </div>
                  <div
                    className="flex flex-col items-center cursor-pointer"
                    onClick={() =>
                      navigate("/wallet/show_Wallet_fund_History", {
                        state: {
                          type: "fundReqHistory",
                        },
                      })
                    }
                  >
                    <Avatar
                      size="large"
                      icon={<RiFundsBoxFill />}
                      className="border-none bg-[#ba7d13]"
                    />
                    <span className="mt-2 text-lg text-white custome text-center">
                      Fund Request History
                    </span>
                  </div>
                  <div
                    className="flex flex-col items-center justify-center cursor-pointer"
                    onClick={() => navigate("/transaction_history")}
                  >
                    <Avatar
                      size="large"
                      icon={<FaMoneyBillTransfer />}
                      className=" border-none bg-[#ba7d13]"
                    />
                    <span className="mt-2 text-lg text-white custome text-center">
                      Transactions History
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {openBet && (
              <Drawer
                title={
                  type === "Withdraw"
                    ? "Enter Withdraw Amount"
                    : " Fund Request "
                }
                placement="bottom"
                closable={false}
                onClose={() => setOpenBet(false)}
                open={openBet}
                extra={
                  <Space>
                    {type === "Withdraw" ? (
                      <Button
                        type="default"
                        onClick={() => {
                          setOpenBet(false);
                          WithdrawRequest();
                        }}
                        className="mt-8 custome rounded-3xl h-8 font-medium text-lg border-none
                     text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                     hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                      >
                        Withdraw
                      </Button>
                    ) : (
                      <Button
                        type="default"
                        disabled={image.length === 0}
                        onClick={() => {
                          setOpenBet(false);
                          FundRequest();
                        }}
                        className="mt-8 custome rounded-3xl h-8 font-medium text-lg border-none
                     text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                     hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                      >
                        Add Fund
                      </Button>
                    )}
                  </Space>
                }
              >
                <InputNumber
                  placeholder="Enter Amount"
                  className="m-2 w-full"
                  value={amount}
                  onChange={(e) => setAmount(e)}
                />

                {type !== "Withdraw" && (
                  <>
                    <Upload
                      maxCount={1}
                      onRemove={() => setImage([])}
                      listType="picture"
                      accept=".jpg, .jpeg, .png"
                      fileList={image}
                      customRequest={handleCustomReq}
                    >
                      <Button
                        className="bg-[#734e0c] text-white border-none font-medium m-2"
                        icon={<IoCloudUploadOutline />}
                      >
                        Click to Upload
                      </Button>
                    </Upload>

                    {image.length === 0 && (
                      <p className="text-red-500 text-sm ml-2 font-medium">
                        Please upload an image to proceed
                      </p>
                    )}
                  </>
                )}
              </Drawer>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Wallet;
